import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import swal from 'sweetalert2';
import AwesomePhonenumber from 'awesome-phonenumber';

import Axios from '@/helpers/axios';
import axios from 'axios';
import router from '@/router';

import client from './client';

Vue.use(VueI18n);
Vue.use(Vuex);

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
const state = {
  loader: true,

  brand: {
    name: '',
    logo: '',
    image: '',
    vips: [],
    shortcuts: [],
    webShortcuts: [],
    keywords: '',
    desc: '',
    price: [],
    stores: [],
    brandImage: [],
  },

  user: {
    cell: '',
    cellFormated: '',
    avatar: '',
    name: '',
    facebookId: null,
    gender: null,
    birthday: null,
    giftNoUsedCount: 0,
  },

  card: {
    type: '',
    image: '',
    avatar: '',
    serial: null,
    barcode: {
      format: '',
      value: '',
      time: 0,
    },
    count: {
      notification: 0,
      coupon: 0,
      point: 0,
    },
    points: 0,
    notifications: [],
    ultrasound: null,
    history: [],
    einvoiceEnable: false,
    downloadAPP: true,
    brandFields: [],
  },

  coupons: [],
  couponShareHistory: [],
  coupon: {
    id: '',
    serial: '',
    brandImage: '',
    image: '',
    name: '',
    used: null,
    expired: null,
    expire: '',
    desc: '',
    comment: '',
    receive: '',
    redeem: null,
    redeemable: false,
    barcode: {
      format: '',
      value: '',
      time: 0,
    },
    gift: false,
    ultrasound: null,
    userCell: null,
    mulitRedeem: false,
  },

  points: [],
  point: {
    token: '',
    type: 'Point',
    title: null,
    point: 0,
    desc: null,
    rewards: [],
    history: [],
    mode: [],
    expire: {
      point: 0,
      date: '',
    },
    goal: 1,
    color: 'F5F5F5',
    bgColor: '9E9E9E',
    badges: [],
    transferEnable: false,
  },
  reward: {
    name: '',
    require: 0,
    image: '',
    desc: '',
    barcode: {
      format: '',
      value: '',
      time: 0,
    },
    ultrasound: null,
  },
};

const getters = {
  /**
   * 是否嵌入 Webview
   * @returns {Boolean}
   */
  inApp: () => false || 'in_app' in router.currentRoute.query,
};

const mutations = {
  setLoader(state, payload) {
    state.loader = payload;
  },
  setOcard(state, payload) {
    state.brand.name = payload.brand.name;

    state.brand.logo = payload.brand.image_logo;
    state.brand.image = payload.brand.image_banner;
    state.brand.vips = payload.vip_list;
    state.brand.shortcuts = payload.shortcut;
    state.brand.webShortcuts = payload.web_sc;
    state.brand.keywords = payload.brand.desc2;
    state.brand.desc = payload.brand.desc;
    state.brand.price = [payload.brand.avg_price, payload.brand.avg_price_h];
    state.brand.stores = payload.store;
    state.brand.brandImage = payload.brand_image || [];
    if (payload.brand_sub) {
      state.brand.subBrand = payload.brand_sub;
    }

    state.user.cell = payload.ocard.cell;
    if (payload.ocard.cell) {
      state.user.cellFormated = new AwesomePhonenumber(payload.ocard.cell, 'TW').getNumber('international').replace(/ /g, '-');
    }
    state.user.name = payload.ocard.name;
    state.user.avatar = payload.ocard.image_head;
    state.user.gender = payload.ocard.sex ? parseInt(payload.ocard.sex, 10) : null;
    state.user.birthday = payload.ocard.birth ? new Date(
      Number(payload.ocard.birth.split('-')[0]),
      Number(payload.ocard.birth.split('-')[1]) - 1,
      Number(payload.ocard.birth.split('-')[2]),
    ) : null;
    state.user.facebookId = payload.ocard.fb_id ? payload.ocard.fb_id : null;
    state.user.giftNoUsedCount = parseInt(payload.gift_no_used_count, 10);

    state.card.id = payload.ocard.id;
    state.card.vip = payload.vip_info;
    state.card.history = payload.vip_log;
    state.card.type = payload.ocard.vip_name;
    state.card.image = payload.ocard.image_card;
    state.card.barcode.format = payload.ocard.barcode.type.toUpperCase();
    state.card.barcode.value = payload.ocard.barcode.code;
    state.card.barcode.show = Boolean(+payload.ocard.barcode.show);
    state.card.barcode.time = payload.ocard.barcode.time || 0;
    state.card.count.coupon = parseInt(payload.ocard.coupon_c, 10);
    state.card.count.point = parseFloat(payload.ocard.point);
    state.card.count.notification = parseInt(payload.ocard.new_notice_c, 10);
    state.card.verifyType = payload.ocard.verify_type;
    state.card.einvoiceEnable = payload.ocard.einvoice_enable;

    if (payload.ocard.show_serial === '1' && payload.ocard.serial) {
      state.card.serial = payload.ocard.serial;
    }

    if (payload.ocard.einvoice_barcode || payload.ocard.einvoice_barcode === null) {
      state.card.einvoiceBarcode = payload.ocard.einvoice_barcode;
    }

    state.coupons = payload.coupon;

    state.couponShareHistory = payload.gift_trans;

    if (payload.points !== null) {
      state.points = payload.points;
    }

    if (payload.disable_download === true) {
      state.card.downloadAPP = false;
    }

    if (payload.ocard.brand_fields.length > 0) {
      const fieldArray = [];
      payload.ocard.brand_fields.forEach((field) => {
        fieldArray.push({
          token: field.field,
          label: field.label,
          value: field.value,
          editable: field.editable,
          mandatory: field.mandatory,
          type: field.type,
          options: field.options,
          help: field.help,
          pattern: field.pattern,
        });
      });
      state.card.brandFields = fieldArray;
    }
  },
  emptyPoint(state) {
    state.point = {
      token: '',
      type: 'Point',
      title: null,
      point: 0,
      desc: null,
      rewards: [],
      history: [],
      mode: [],
      expire: {
        point: 0,
        date: '',
      },
      goal: 1,
      color: 'F5F5F5',
      bgColor: '9E9E9E',
      badges: [],
    };
  },
  setPoint(state, payload) {
    state.point.token = payload.token;
    state.point.type = payload.card.type;
    state.point.title = payload.card.title;
    state.point.point = payload.card.point;
    state.point.desc = payload.card.content;
    state.point.rewards = payload.gift;
    state.point.history = payload.record;
    state.point.mode = payload.card.mode.toUpperCase().split(',');
    state.point.transferEnable = payload.card.transfer_enable;

    if ('expire' in payload) {
      state.point.expire = payload.expire;
    }

    if (payload.card.type === 'MILESTONE') {
      state.point.color = payload.card.color;
      state.point.bgColor = payload.card.bg_color;
      state.point.goal = payload.card.goal;
      state.point.badges = payload.badges;
    }
  },
  setOcardUltrasound(state, payload) {
    state.card.ultrasound = payload;
  },
  clearNotificationCount() {
    state.card.count.notification = 0;
  },
  setCoupon(state, payload) {
    state.coupon.id = payload.idx;
    state.coupon.serial = payload.id;
    state.coupon.brandImage = payload.image_bg;
    state.coupon.image = payload.image;
    state.coupon.name = payload.title;
    state.coupon.used = Boolean(+payload.used);
    state.coupon.usedTimestamp = payload.used_time;
    state.coupon.expired = Boolean(+payload.expired);
    state.coupon.receive = payload.create_time;
    state.coupon.valid = payload.start_time;
    state.coupon.expire = payload.end_time;
    state.coupon.desc = payload.content;
    state.coupon.comment = payload.comment;
    state.coupon.redeem = parseInt(payload.redeem_type, 10);
    state.coupon.redeemable = payload.redeemable;
    state.coupon.gift = payload.gift_enable === '1';
    state.coupon.multiRedeem = payload.multi_enable;
    state.brand.name = payload.brand_name;
    state.ultrasound = null;

    if (parseInt(payload.redeem_type, 10) === 3) {
      state.coupon.barcode.format = payload.barcode.type.toUpperCase();
      state.coupon.barcode.value = payload.barcode.code;
      state.coupon.barcode.time = payload.barcode.time || 0;
    }

    if ('multi_info' in payload) {
      state.coupon.current = payload.multi_info.current;
      state.coupon.total = payload.multi_info.total;
      state.coupon.prev = payload.multi_info.prev;
      state.coupon.next = payload.multi_info.next;
    }

    if ('user_cell' in payload) {
      state.coupon.userCell = new AwesomePhonenumber(payload.user_cell, 'TW').getNumber('international').replace(/ /g, '-');
    }
  },
  setCouponUltrasound(state, payload) {
    state.coupon.ultrasound = payload;
  },
  couponUsed(state) {
    state.coupon.used = true;
    state.coupon.usedTimestamp = new Date();
  },
  emptyCoupon(state) {
    state.coupon = {
      id: '',
      serial: '',
      brandImage: '',
      image: '',
      name: '',
      used: null,
      expired: null,
      expire: '',
      desc: '',
      comment: '',
      receive: '',
      redeem: null,
      barcode: {
        format: '',
        value: '',
        time: 0,
      },
      gift: false,
      ultrasound: null,
    };
  },
  setReward(state, payload) {
    state.reward.name = payload.title;
    state.reward.id = payload.idx;
    state.reward.require = parseInt(payload.require_point, 10);
    state.reward.image = payload.image;
    state.reward.desc = payload.content;
    state.reward.token = payload.token;
    state.reward.redeemViaOboss = payload.redeem_type === '0';
    state.reward.redeemViaBarcode = payload.redeem_type === '3';
    state.reward.redeemViaUltrasound = payload.redeem_type === '4';
    state.reward.redeemViaOnline = payload.redeem_type === '2';
    state.reward.multiRedeem = payload.multi_enable === '1';
    if ('barcode' in payload) {
      state.reward.barcode = payload.barcode;
      state.reward.barcode.format = payload.barcode.type.toUpperCase();
      state.reward.barcode.value = payload.barcode.code;
      state.reward.barcode.show = Boolean(state.reward.barcode.show);
      state.reward.barcode.time = payload.barcode.time || 0;
    }

    delete state.reward.remain;

    if ('remain_count' in payload) {
      state.reward.remain = payload.remain_count;
    }
  },
  setRewardUltrasound(state, payload) {
    state.reward.ultrasound = payload;
  },
};

const actions = {
  toggleLoader({ commit }, value) {
    commit('setLoader', value);
  },
  getCard({ commit, dispatch }) {
    const data = {
      ...state.route.query,
      p: state.client.phoneType,
      dtk: state.client.dtk,
      brand_id: state.route.params.brand,
    };

    Axios({
      method: 'post',
      url: 'v2/Ocard/GetUsersOcard',
      data,
    })
      .then((response) => {
        if (response.data.code === 500) {
          commit('setOcard', response.data.data);
          if (response.data.data.ocard.verify_type === 4) {
            dispatch('getOcardUltrasound', response.data.data.ocard.id);
          }
          commit('setLoader', false);
          // Vue.gtm.trackEvent({
          //   event: '設定 User ID',
          //   userId: response.data.data.ocard.id,
          // });
        } else if (response.data.code === 305) {
          // Bearer 過期
          commit('clearUtk');
          router.push({
            name: 'Entry',
            query: {
              ...state.route.query,
              r: encodeURIComponent(window.location.href),
            },
          });
        } else if (response.data.code === 491) {
          // 未接受 VIP
          router.push({
            name: 'Entry',
            query: {
              ...state.route.query,
              r: encodeURIComponent(window.location.href),
            },
          });
        }
      });
  },
  getOcardUltrasound({ commit }, id) {
    axios.get(`https://sound-generator.aimazing.com.sg/labcrawl_ticket/C${id}`)
      .then((response) => {
        commit('setOcardUltrasound', `https://sound-generator.aimazing.com.sg${response.data.mp3}`);
      });
  },
  getPoint({ commit }, token) {
    commit('setLoader', true);

    const data = {
      ...state.route.query,
      p: state.client.phoneType,
      dtk: state.client.dtk,
      brand_id: state.route.params.brand,
      _point_activity: token,
    };

    Axios({
      method: 'post',
      url: '/v2/ocard/pointCard',
      data,
    })
      .then((response) => {
        commit('setPoint', response.data.data);
        commit('setLoader', false);
      });
  },
  getCoupon({ commit, dispatch }, value) {
    commit('setLoader', true);
    const data = {
      p: state.client.phoneType,
      dtk: state.client.dtk,
      brand_id: state.route.params.brand,
      serial: value,
      multi: '1',
    };

    Axios({
      method: 'post',
      url: '/Coupon/GetCoupon',
      data: Object.assign(data, state.route.query),
    })
      .then((response) => {
        if (response.data.code === 500) {
          commit('setLoader', false);
          commit('setCoupon', response.data.data);
          if (response.data.data.redeem_type === '4') {
            dispatch('getCouponUltrasound', response.data.data.id);
          }
        } else if (response.data.code === 305) {
          commit('setLoader', false);
          commit('clearUtk');
          router.push({
            name: 'Entry',
            query: {
              ...state.route.query,
              r: encodeURIComponent(window.location.href),
            },
          });
        } else if (response.data.code === 495) {
          // 不存在的券
          commit('setLoader', true);
          swal.fire({
            text: response.data.msg,
          })
            .then(() => {
              router.push({
                name: 'Coupons',
                query: {
                  ...state.route.query,
                },
              });
            });
        }
      });
  },
  getCouponUltrasound({ commit }, id) {
    axios.get(`https://sound-generator.aimazing.com.sg/labcrawl_ticket/R${id}`)
      .then((response) => {
        commit('setCouponUltrasound', `https://sound-generator.aimazing.com.sg${response.data.mp3}`);
      });
  },
  useCoupon({ commit }, payload) {
    const data = {
      p: state.client.phoneType,
      dtk: state.client.dtk,
      brand_id: state.route.params.brand,
      cid: payload.id,
      lat: payload.lat,
      lng: payload.lng,
    };

    if (payload.redeem) {
      data.redeem_code = payload.redeem;
    }

    if (payload.amount > 1) {
      data.amount = payload.amount;
    }

    Axios({
      method: 'post',
      url: '/Coupon/UseCoupon',
      data: Object.assign(data, state.route.query),
    })
      .then((response) => {
        if (response.data.code === 500) {
          // Vue.gtm.trackEvent({
          //   event: '兌換禮物券',
          //   label: `${state.brand.name} - ${payload.name}`,
          // });

          swal.fire({
            text: response.data.msg,
          });

          commit('couponUsed');
        } else {
          swal.fire({
            text: response.data.msg,
          });
        }
      });
  },
};

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    client,
  },
});

export default store;
